export const homePageSchema = {
  '@context': 'https://schema.org ',
  '@type': 'TelecommunicationsService',
  name: 'Bakcell',
  alternateName: 'Azərbaycanın ən sürətli mobil şəbəkəsi',
  url: 'https://www.bakcell.com/ ',
  logo: 'https://www.bakcell.com/data/new-logo.svg',
  sameAs: [
    'https://www.facebook.com/Bakcell ',
    'https://www.instagram.com/bakcell/ ',
    'https://www.linkedin.com/company/bakcell/',
  ],
  areaServed: { '@type': 'Country', name: 'Azerbaijan' },

  availableLanguage: [
    { '@type': 'Language', name: 'Azerbaijani' },

    { '@type': 'Language', name: 'English' },

    { '@type': 'Language', name: 'Russian' },
  ],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+994124988989',
      contactType: 'customer service',
      areaServed: 'AZ',
      availableLanguage: ['az', 'en', 'ru'],
    },

    {
      '@type': 'ContactPoint',
      telephone: '555',
      contactType: 'mobile support',
      areaServed: 'AZ',
      availableLanguage: ['az', 'en', 'ru'],
    },

    {
      '@type': 'ContactPoint',
      email: 'info@bakcell.com',
      contactType: 'information',
      availableLanguage: ['az', 'en', 'ru'],
    },
  ],
  serviceType: 'Mobile Telecommunications',
  provider: { '@type': 'Organization', name: 'Bakcell MMC' },

  hasPart: {
    '@type': 'WebSite',
    name: 'Bakcell',
    url: 'https://www.bakcell.com/ ',
    potentialAction: [
      {
        '@type': 'SearchAction',
        target:
          'https://www.bakcell.com/search?q=%7Bsearch_term_string%7D&type=individual ',
        'query-input': 'required name=search_term_string',
      },

      {
        '@type': 'SearchAction',
        target:
          'https://www.bakcell.com/search?q=%7Bsearch_term_string%7D&type=corporate ',
        'query-input': 'required name=search_term_string',
      },
    ],
  },
};
